// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerProjectTable
{
    font-size: small;
    line-height: 1;
}

.headerProjectTableLeft
{
    text-align: right;
    color: gray;
}

.headerProjectTableRight
{
    text-align: left;
    color: white;
    padding-left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appheader/appheader.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,iBAAiB;IACjB,WAAW;AACf;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB","sourcesContent":[".headerProjectTable\n{\n    font-size: small;\n    line-height: 1;\n}\n\n.headerProjectTableLeft\n{\n    text-align: right;\n    color: gray;\n}\n\n.headerProjectTableRight\n{\n    text-align: left;\n    color: white;\n    padding-left: 4px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
